import { TPoint } from '../../../points/points.model';
import { TColumn } from '../columns/column.model';
import { sortText } from './sort-text';
import { sortId } from './sort-id';
import { sort } from './sorting';

export function sortTitle(
  firstPoint: TPoint,
  secondPoint: TPoint,
  sortColumns: Partial<TColumn>[],
  index: number,
): number {
  const result = sortText(firstPoint, secondPoint, sortColumns, index, {
    property: 'title',
  });

  if (result) {
    return result;
  }

  if (sortColumns[index + 1]) {
    return sort(firstPoint, secondPoint, sortColumns, index + 1);
  } else {
    return sortId(firstPoint, secondPoint, sortColumns, index);
  }
}
